import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
import { MemberBalanceItem } from '../../BalanceItemDetailed';
import { RegisterCartValidator } from './RegisterCartValidator';
/**
 * Version destined for the server and client side storage
 */
export class IDRegisterItem extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.waitingList = false;
        /**
         * Will get validated. Is used to check if the price has changed between frontend and backend
         */
        this.calculatedPrice = 0;
    }
    convert(organization, members) {
        const group = organization.groups.find(g => g.id === this.groupId);
        if (!group) {
            return null;
        }
        const member = members.find(g => g.id === this.memberId);
        if (!member) {
            return null;
        }
        return new RegisterItem(member, group, this);
    }
    validate(family, groups, categories, previousItems) {
        RegisterCartValidator.validateItem(this, family, groups, categories, previousItems);
    }
}
__decorate([
    field({ decoder: StringDecoder })
], IDRegisterItem.prototype, "memberId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], IDRegisterItem.prototype, "groupId", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], IDRegisterItem.prototype, "reduced", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], IDRegisterItem.prototype, "waitingList", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], IDRegisterItem.prototype, "calculatedPrice", void 0);
/**
 * Used in memory in the client
 * Do not extend IDRegisterItem to prevent leaking information when encoding a RegisterItem as IDRegisterItem.
 * This version is not encodeable
 */
export class RegisterItem {
    /**
     * Unique identifier to check if two cart items are the same
     */
    get id() {
        return this.member.id + "." + this.group.id;
    }
    get groupId() {
        return this.group.id;
    }
    get memberId() {
        return this.member.id;
    }
    constructor(member, group, settings) {
        this.reduced = false;
        this.waitingList = false;
        this.calculatedPrice = 0;
        this.member = member;
        this.group = group;
        this.reduced = settings.reduced;
        this.waitingList = settings.waitingList;
    }
    convert() {
        return IDRegisterItem.create(Object.assign({
            memberId: this.member.id,
            groupId: this.group.id,
            calculatedPrice: this.calculatedPrice
        }, this));
    }
    validate(family, groups, categories, previousItems) {
        RegisterCartValidator.validateItem(this, family, groups, categories, previousItems);
    }
}
/**
 * Contains an intention to pay for an outstanding balance item
 */
export class BalanceItemCartItem extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Amount you want to pay of that balance item
         */
        this.price = 0;
    }
    get id() {
        return this.item.id;
    }
    validate(balanceItems) {
        const found = balanceItems.find(b => b.id === this.item.id);
        if (!found) {
            throw new SimpleError({
                code: "not_found",
                message: "Eén van de openstaande bedragen is niet meer beschikbaar."
            });
        }
        this.item = found;
        const maxPrice = MemberBalanceItem.getOutstandingBalance([found]).total; // Allow to start multiple payments for pending balance items in case of payment cancellations
        if (maxPrice === 0) {
            throw new SimpleError({
                code: "not_found",
                message: "Eén van de openstaande bedragen is ondertussen al betaald."
            });
        }
        if (maxPrice < 0) {
            // Allow negative prices
            if (this.price > 0) {
                this.price = maxPrice;
            }
            if (this.price < maxPrice) {
                // Don't throw: we'll throw a different error during checkout if the price has changed
                this.price = maxPrice;
            }
            return;
        }
        if (this.price < 0) {
            this.price = maxPrice;
        }
        if (this.price > maxPrice) {
            // Don't throw: we'll throw a different error during checkout if the price has changed
            this.price = maxPrice;
        }
    }
}
__decorate([
    field({ decoder: MemberBalanceItem })
], BalanceItemCartItem.prototype, "item", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], BalanceItemCartItem.prototype, "price", void 0);
//# sourceMappingURL=RegisterItem.js.map